import { gql } from '@apollo/client'

import { PAYMENT_METHOD_FRAGMENTS, USER_FRAGMENTS, INVOICE_FRAGMENTS } from '@/gql/user'
import { ACCOUNT_FRAGMENTS, RENEWAL_PREVIEW_FRAGMENTS, SUBSCRIPTIONS_FRAGMENTS } from '@/gql/account'
import { PLAN_FRAGMENTS } from '@/gql/plans'

export const INITIAL_LOAD = gql`
  query initialLoad {
    account {
      ...AccountFragments
    }
    user {
      ...UserFragments
    }
    subscriptions {
      ...SubscriptionsFragments
    }
    paymentMethod {
    ...PaymentMethodFragments
    }
    invoices {
        ...InvoiceFragments
    }
    plans {
      ...PlanFragments
    }
    renewalPreview {
      ...RenewalPreviewFragments
    }
  }
  ${USER_FRAGMENTS}
  ${ACCOUNT_FRAGMENTS}
  ${SUBSCRIPTIONS_FRAGMENTS}
  ${PAYMENT_METHOD_FRAGMENTS}
  ${INVOICE_FRAGMENTS}
  ${PLAN_FRAGMENTS}
  ${RENEWAL_PREVIEW_FRAGMENTS}
`

export default {}
